import addScore from "../../Shared/functions/addScore";

export default function getScenarioTotalScore(scenarioReps) {
	const totalScore = Object.values(scenarioReps).reduce((acc, cur) => {
		return addScore(acc, cur);
	}, "0/0");
	return totalScore;
}
